import { cn } from '@utils'

export default function NavItem({
  children,
  primary: important,
  className,
}: {
  children: React.ReactNode
  primary?: boolean
  className?: string
}) {
  return (
    <li className={cn(important ? '' : 'hidden @header-nav:block', className)}>
      {children}
    </li>
  )
}
